export type ReportObjectType = 'USER' | 'GROUP';

export class ReportObjectId {
    reportId?: number;
    objectId?: string;
    type?: ReportObjectType;
}

/** Asignación de un usuario o grupo (collection) que puede ver un reporte */
export class ReportObject {
    id?: ReportObjectId;
}
